<header appScrollNav #header id="top" class="header" [nav]="nav" [class.light-background]="!isHomePage"
  style="z-index: 20;">
  <div class="header-container">
    <div class="header-logo">
      <a aria-label="scroll to top" class="top-icon" accesskey="h" [routerLink]="language === 'en' ? [''] : [language]" (click)="scrollPageToTop()">
        <img width="195" height="35" alt="caseactive full logo" class="top-logo full" loading="eager" src="images/caseactive-full-logo.png" />
        <img width="28" height="23" alt="caseactive small logo" class="top-logo short" loading="eager" src="images/logo-short.png" />
      </a>
    </div>
    <nav #nav class="navbar">
      <ul class="navbar-pages" [class.opened]="isMobileMenuShown">
        <li class="navbar-pages__item"><a class="link" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active" [routerLink]="language === 'en' ? ['overview'] : [language, 'overview']">{{ 'Overview' | translate }}</a></li>
        <li class="navbar-pages__item"><a class="link" routerLinkActive="active" [routerLink]="language === 'en' ? ['pricing'] : [language, 'pricing']">{{ 'Pricing' | translate }}</a></li>
        <li class="navbar-pages__item dropdown">
          <span tabindex="0" [class.active]="resourcesRoute" class="link dropdown-trigger">{{ 'Resources' | translate }} <img width="14" height="14" loading="eager" alt="resources arrow down" src="images/icons/arrow-down.svg" /></span>
          <ul class="dropdown-content" [class.hide]="isDropdownHidden">
            <li class="dropdown-item">
              <a [routerLink]="language === 'en' ? ['faq'] : [language, 'faq']" routerLinkActive="active"
                class="link dropdown-item__link">{{ 'FAQs' | translate }}</a>
              <a [routerLink]="language === 'en' ? ['blog'] : [language, 'blog']" routerLinkActive="active"
                class="link dropdown-item__link">{{ 'Blog' | translate }}</a>
              <a [routerLink]="language === 'en' ? ['documentation'] : [language, 'documentation']" routerLinkActive="active" class="link dropdown-item__link">{{ 'Documentation' | translate }}</a>
            </li>
          </ul>
        </li>
        <li class="navbar-pages__item"><a class="link" routerLinkActive="active" [routerLink]="language === 'en' ? ['contact'] : [language, 'contact']">{{ 'Contact' | translate }}</a></li>
        <li class="navbar-pages__item languages-mobile">
          <div class="languages languages-mobile">
            <ng-container *ngTemplateOutlet="languages"></ng-container>
          </div>
        </li>
      </ul>
      <div class="navbar-actions">
        <div class="languages languages-desktop">
          <ng-container *ngTemplateOutlet="languages"></ng-container>
        </div>
        <button (click)="goToLogin()" class="tertiary">
          <span class="navbar-actions__text">{{ 'Log In' | translate }}</span>
          <img class="navbar-actions__img" width="32" height="32" src="images/icons/login.svg" loading="eager" alt="login">
        </button>
        <button (click)="goToSignup()" class="primary get-started">{{ 'Start Free' | translate }}</button>
        <button (click)="showHideMobileMenu()" class="navbar-actions__menu"><img width="32" height="32" src="images/icons/menu.svg" loading="eager" alt="menu"></button>
      </div>
    </nav>
  </div>
</header>

<ng-template #languages>
  <app-select-language 
    id="language" 
    class="switchLanguage" 
    [locale]="locale" 
    [filteredLanguages]="filteredLanguages" 
    [popularLanguages]="popularLanguages" 
    (languageChange)="onLanguageChange()"
  />
</ng-template>
